/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function SmileyXEyes(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M128,24A104,104,0,1,0,232,128,104.12041,104.12041,0,0,0,128,24Zm-18.34375,98.34375a7.99915,7.99915,0,1,1-11.3125,11.3125L88,123.3125,77.65625,133.65625a7.99915,7.99915,0,0,1-11.3125-11.3125L76.6875,112,66.34375,101.65625a7.99915,7.99915,0,0,1,11.3125-11.3125L88,100.6875,98.34375,90.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L99.3125,112ZM128,192a12,12,0,1,1,12-12A12.0006,12.0006,0,0,1,128,192Zm61.65625-69.65625a7.99915,7.99915,0,1,1-11.3125,11.3125L168,123.3125l-10.34375,10.34375a7.99915,7.99915,0,0,1-11.3125-11.3125L156.6875,112l-10.34375-10.34375a7.99915,7.99915,0,0,1,11.3125-11.3125L168,100.6875l10.34375-10.34375a7.99915,7.99915,0,0,1,11.3125,11.3125L179.3125,112Z" />
    </Svg>
  );
}

export default SmileyXEyes;
